import {
 Box,
 Button,
 LinearProgress,
 linearProgressClasses,
 Stack,
 Typography,
} from '@mui/material';
import { useMemo, useState } from 'react';

import customColors from '../../../utils/customColors';
import { WidgetItemType } from '../Dashboard.types';

const DashboardWidgetProgress = ({
 widgetContent,

 totalSum,
}: {
 widgetContent: WidgetItemType[];

 totalSum: number;
}) => {
 const getAggregateValue = (item: WidgetItemType): number =>
  item.Aggregates['CargoNeto.sum'] ?? item.Aggregates['neto.sum'] ?? 0;

 const colorMap = useMemo(() => {
  const colors: ('success' | 'error' | 'warning' | 'info')[] = [
   'success',
   'error',
   'warning',
   'info',
  ];
  const map = new Map<string, 'success' | 'error' | 'warning' | 'info'>();
  widgetContent.forEach((item, index) => {
   map.set(item.Key, colors[index % colors.length]);
  });
  return map;
 }, [widgetContent]);

 const [currentPage, setCurrentPage] = useState(1);
 const itemsPerPage = 10;
 const totalPages = Math.ceil(widgetContent.length / itemsPerPage);
 const startIndex = (currentPage - 1) * itemsPerPage;
 const endIndex = startIndex + itemsPerPage;
 const currentItems = widgetContent.slice(startIndex, endIndex);

 const handlePreviousPage = () => {
  setCurrentPage((prev) => Math.max(prev - 1, 1));
 };

 const handleNextPage = () => {
  setCurrentPage((prev) => Math.min(prev + 1, totalPages));
 };
 console.log(currentItems);
 console.log(totalSum);

 return (
  <Box
   sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    overflow: 'auto',
   }}
  >
   <Box
    sx={{
     display: 'flex',
     flexDirection: 'column',
     gap: 2,
     pr: 2,
     overflow: 'auto',
    }}
   >
    {currentItems.map((item) => (
     <Box key={item.Key}>
      <Box sx={{ display: 'flex', gap: '12px', mb: '4px' }}>
       <Typography sx={{ fontSize: 12, marginRight: 'auto' }}>
        {item.Key}
       </Typography>

       <Typography sx={{ fontSize: 12 }}>
        {getAggregateValue(item).toLocaleString()} t
       </Typography>

       <Typography sx={{ fontSize: 12, color: customColors.gray }}>
        {((getAggregateValue(item) / totalSum) * 100).toFixed(2)}%
       </Typography>
      </Box>

      <LinearProgress
       sx={{
        borderRadius: 4,

        [`& .${linearProgressClasses.bar}`]: {
         borderRadius: 4,
        },
       }}
       color={colorMap.get(item.Key) ?? 'info'}
       variant="determinate"
       value={(getAggregateValue(item) / totalSum) * 100}
      />
     </Box>
    ))}
   </Box>

   {totalPages > 1 && (
    <Stack
     direction="row"
     justifyContent="center"
     alignItems="center"
     spacing={2}
     sx={{}}
    >
     <Button
      variant="outlined"
      size="small"
      onClick={handlePreviousPage}
      disabled={currentPage === 1}
      sx={{ minWidth: '80px' }}
     >
      Previous
     </Button>
     <Typography variant="body2" sx={{ minWidth: '60px', textAlign: 'center' }}>
      {currentPage} / {totalPages}
     </Typography>
     <Button
      variant="outlined"
      size="small"
      onClick={handleNextPage}
      disabled={currentPage === totalPages}
      sx={{ minWidth: '80px' }}
     >
      Next
     </Button>
    </Stack>
   )}
  </Box>
 );
};

export default DashboardWidgetProgress;
